import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from "../../App.js";


//Import AwesomeIcon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTiktok, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

//Import css
import './dataRemainingCompt.css';

//Import Assets
import LogoWebmedia from '../../assets/homeAssets/logoWebMedia.svg'
import iconSobreData from '../../assets/dataRemaining/dataPhotoMensaje.svg' 
import IconLaptop from '../../assets/dataRemaining/laptopPhoto.svg'

//Import Component
import { BarraMenuDown } from '../home/barraMenuDown';
import { PanelMenuSlideDV } from '../developComponent/panelMenuSlideDV';
import { CountdownTimer } from './CountdownTimer.js'


export function DataRemainingCompt() {


    const {

        //Panel Menu Slide Dv
        openMenuSlideDv,
        setOpenMenuSlideDv,
        valorScreenDv,
        setValorScreenDv

    } = useContext(AppContext);


    return(
        <div className="container-data-remaining">

                <BarraMenuDown />

                <PanelMenuSlideDV
                
                    activeMenu='email-marketing'
                
                />



            {/* SECCION BOTON Y LOGO   */}
            <div className='box-btn-slide-logo-dv'>

                <div className='box-btn-menu-slide-dv'>

                    <button className="btn-menu-slide-dv" onClick={() => setOpenMenuSlideDv(!openMenuSlideDv)}>
                        
                        <span id='btn-slide-menu-open-dv' className="material-symbols-outlined">menu</span>
                        
                    </button>

                </div>


                <div className='box-logo-webmedia-dv'>

                    <img className='logo-webmedia-dv' src={LogoWebmedia} alt="Logo WebMedia"/>

                </div>

            </div>


            {/* SECCION BOX CONTACTO   */}
            <div className='box-data-remaining'>

                <div className='box-block-A-photo'>

                    <img className='photo-sobre-data' src={iconSobreData}/>
                    <img className='photo-laptop-data' src={IconLaptop}/>

                </div>

                <div className='box-block-B-countdown'>

                    <div className='box-content-countdown'>

                        <p className='text-contdown'>ACTUALIZANDO DATOS </p>
                        <p className='text-time-remaining'>Time Remaining</p>

                        <CountdownTimer 
                            duration={604800}
                        />

                    </div>

                </div>


            </div>

        </div>
    );



}